import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/Home'
import Login from '@/components/auth/Login'
import ItemBank from '@/components/itembank/ItemBank'
import ItemBankForm from '@/components/itembank/Form'
import Tryout from '@/components/tryout/Tryout'
import TryoutForm from '@/components/tryout/Form'
import TryoutExport from '@/components/tryout/TryoutExport'
import TryoutImport from '@/components/tryout/TryoutImport'
import TryoutRevision from '@/components/tryout/Revisi'

import SubtestForm from '@/components/tryout/SubtestForm'
import TryoutGroup from '@/components/tryout_group/TryoutGroup'
import TryoutGroupForm from '@/components/tryout_group/Form'
import UserManagement from '@/components/usman/UserManagement'
import UserManagementDetail from '@/components/usman/UserManagementDetail'
import UserBulkActivation from '@/components/usman/UserBulkActivation'
import TopicManagement from '@/components/kodifikasi/TopicManagement'
import TopicManagementDetail from '@/components/kodifikasi/TopicManagementDetail'
import TopicMapping from '@/components/kodifikasi/TopicMapping'
import TopicMappingDetail from '@/components/kodifikasi/TopicMappingDetail'
import TryoutSerial from '@/components/serial/Serial'
import TryoutSerialForm from '@/components/serial/Form'
import VdPembelajaran from '@/components/vd_pembelajaran/VdPembelajaran'
import VdPembelajaranForm from '@/components/vd_pembelajaran/Form'
import ModulBelajar from '@/components/modul_pembelajaran/ModulBelajar'
import ModulBelajarForm from '@/components/modul_pembelajaran/Form'
import ModulBelajarMaterial from '@/components/modul_pembelajaran/ModulBelajarMaterial'
import ModulBelajarLiveStream from '@/components/modul_pembelajaran/ModulBelajarLiveStream'
import Pembayaran from '@/components/pembayaran/Pembayaran'
import PembayaranDetail from '@/components/pembayaran/PembayaranDetail'
import MetodePembayaran from '@/components/pembayaran/MetodePembayaran'
// import MetodePembayaranForm from '@/components/pembayaran/MetodePembayaranForm'
import MetodePembayaranForm from '@/components/pembayaran/MetodePembayaranFormV2'
import PembayaranForm from '@/components/pembayaran/Form'
import Produk from '@/components/pembayaran/Produk'
import ProdukForm from '@/components/pembayaran/ProdukForm'
import TicketUsage from '@/components/pembayaran/TicketUsage'
import TicketUsageDetail from '@/components/pembayaran/TicketUsageDetail'
import KatalogTiket from '@/components/pembayaran/KatalogTiket'
import KatalogTiketForm from '@/components/pembayaran/KatalogTiketForm'
import RegisterLiga from '@/components/duel/register_liga/RegisterLiga'
import RegisterLigaForm from '@/components/duel/register_liga/RegisterLigaForm'
import Season from '@/components/duel/season/Season'
import SeasonForm from '@/components/duel/season/SeasonForm'
import LigaPersonalMenu from '@/components/duel/liga_personal/LigaPersonalMenu'
import LigaPersonalBrackets from '@/components/duel/liga_personal/LigaPersonalBrackets'
import LigaSekolahMenu from '@/components/duel/liga_sekolah/LigaSekolahMenu'
import LigaSekolahBrackets from '@/components/duel/liga_sekolah/LigaSekolahBrackets'

import PaketMapel from '@/components/bimbel_online/paket_mapel/ListPaketMapel'
import PaketMapelDetail from '@/components/bimbel_online/paket_mapel/PaketMapel'
import FormMapel from '@/components/bimbel_online/paket_mapel/Form'

import PaketBimbel from '@/components/bimbel_online/paket_bimbel/ListPaketBimbel'
import FormBimbel from '@/components/bimbel_online/paket_bimbel/Form'

import Content from '@/components/home_setting/content/Content'
import FormContent from '@/components/home_setting/content/Form'

import ContentArticle from '@/components/home_setting/article/Article'
import FormArticle from '@/components/home_setting/article/Form'

import ContentMenu from '@/components/home_setting/menu/Menu'
import FormMenu from '@/components/home_setting/menu/Form'

import ContentVideo from '@/components/home_setting/free_video/FreeVideo'
import FormVideo from '@/components/home_setting/free_video/Form'

import ContentBanner from '@/components/home_setting/banner/Banner'
import FormBanner from '@/components/home_setting/banner/Form'

import ContentFreeItemBank from '@/components/home_setting/free_itembank/FreeItemBank'
import FormFreeItemBank from '@/components/home_setting/free_itembank/Form'
import FreeItemBankImport from '@/components/home_setting/free_itembank/ItemBankImport'

import PreviewContent from '@/components/home_setting/preview_setting_content/Preview'

import Organizations from '@/components/organizations/Organizations'
import OrganizationDetail from '@/components/organizations/OrganizationDetail'
import OrganizationForm from '@/components/organizations/OrganizationForm'
import OrganizationsActivation from '@/components/organizations/OrganizationsActivation'

import ConfigurationManagementForm from '@/components/config_management/Form'

import Sbmptn from '@/components/sbmptn/Sbmptn'
import Top10UtbkRank from '@/components/sbmptn/Top10Ranking'

import Voucher from '@/components/voucher/Voucher'
import VoucherForm from '@/components/voucher/Form'


import AdsForm from '@/components/iklan/Form'

import AffDashboard from '@/components/affiliate/dashboard/AffiliateDashboard'
import AffRedeem from '@/components/affiliate/redeem/AffiliateRedeem'
import AffSetting from '@/components/affiliate/setting/AffiliateSetting'

import Regrading from '@/components/regrading/Regrading'

import PushNotif from '@/components/push_notif/PushNotif'

import Teachers from '@/components/teacher/Teachers'
import TeacherDetail from '@/components/teacher/TeacherDetail'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/items',
      name: 'ItemBank',
      component: ItemBank
    },
    {
      path: '/item-form',
      name: 'ItemBankForm',
      component: ItemBankForm
    },
    {
      path: '/tryouts',
      name: 'Tryout',
      component: Tryout
    },
    {
      path: '/tryout-form',
      name: 'TryoutForm',
      component: TryoutForm
    },

    {
      path: '/tryout-export',
      name: 'TryoutExport',
      component: TryoutExport
    },

    {
      path: '/tryout-revisi',
      name: 'TryoutRevision',
      component: TryoutRevision
    },

    {
      path: '/tryout-import',
      name: 'TryoutImport',
      component: TryoutImport
    },

    {
      path: '/subtest-form',
      name: 'SubtestForm',
      component: SubtestForm
    },
    {
      path: '/tryout-groups',
      name: 'TryoutGroup',
      component: TryoutGroup
    },
    {
      path: '/tryout-group/form',
      name: 'TryoutGroupForm',
      component: TryoutGroupForm
    },
    {
      path: '/user-management',
      name: 'UserManagement',
      component: UserManagement
    },

    {
      path: '/user-management/bulk-activation',
      name: 'UserManagement',
      component: UserBulkActivation
    },

    {
      path: '/user-detail',
      name: 'UserManagementDetail',
      component: UserManagementDetail
    },
    {
      path: '/topic-management',
      name: 'TopicManagement',
      component: TopicManagement
    },
    {
      path: '/topic-management/detail',
      name: 'TopicManagementDetail',
      component: TopicManagementDetail
    },
    {
      path: '/topic-mapping',
      name: 'TopicMapping',
      component: TopicMapping
    },
    {
      path: '/topic-mapping/detail',
      name: 'TopicMappingDetail',
      component: TopicMappingDetail
    },
    {
      path: '/serial',
      name: 'TryoutSerial',
      component: TryoutSerial
    },
    {
      path: '/serial/form',
      name: 'TryoutSerialForm',
      component: TryoutSerialForm
    },
    {
      path: '/video',
      name: 'VideoPembelajaran',
      component: VdPembelajaran
    },
    {
      path: '/video/form',
      name: 'VideoPembelajaranForm',
      component: VdPembelajaranForm
    },
    {
      path: '/video/material/form',
      name: 'VideoMaterial',
      component: VdPembelajaranForm
    },
    {
      path: '/video/material/live-stream/form',
      name: 'VideoMaterialLiveStream',
      component: VdPembelajaranForm
    },
    {
      path: '/modul-belajar',
      name: 'ModulBelajar',
      component: ModulBelajar
    },
    {
      path: '/modul-belajar/form',
      name: 'ModulBelajarForm',
      component: ModulBelajarForm
    },
    {
      path: '/modul-belajar/materials',
      name: 'ModulBelajarMaterial',
      component: ModulBelajarMaterial
    },
    {
      path: '/modul-belajar/live-stream',
      name: 'ModuleBelajarLiveStream',
      component: ModulBelajarLiveStream
    },
    {
      path: '/pembayaran',
      name: 'Pembayaran',
      component: Pembayaran
    },
    {
      path: '/pembayaran/detail',
      name: 'PembayaranDetail',
      component: PembayaranDetail
    },
    {
      path: '/pembayaran/form',
      name: 'PembayaranForm',
      component: PembayaranForm
    },
    {
      path: '/metode-pembayaran',
      name: 'MetodePembayaran',
      component: MetodePembayaran
    },
    {
      path: '/metode-pembayaran/form',
      name: 'MetodePembayaranForm',
      component: MetodePembayaranForm
    },
    {
      path: '/produk',
      name: 'Produk',
      component: Produk
    },
    {
      path: '/produk/form',
      name: 'ProdukForm',
      component: ProdukForm
    },
    {
      path: '/ticket-usage',
      name: 'TicketUsage',
      component: TicketUsage
    },
    {
      path: '/ticket-usage/detail',
      name: 'TicketUsageDetail',
      component: TicketUsageDetail
    },
    {
      path: '/katalog-tiket',
      name: 'KatalogTiket',
      component: KatalogTiket
    },
    {
      path: '/katalog-tiket/form',
      name: 'KatalogTiketForm',
      component: KatalogTiketForm
    },
    {
      path: '/register-liga/',
      name: 'RegisterLiga',
      component: RegisterLiga
    },
    {
      path: '/register-liga/form',
      name: 'RegisterLigaForm',
      component: RegisterLigaForm
    },
    {
      path: '/season/',
      name: 'Season',
      component: Season
    },
    {
      path: '/season/form',
      name: 'SeasonForm',
      component: SeasonForm
    },
    {
      path: '/liga-personal',
      name: 'LigaPersonalMenu',
      component: LigaPersonalMenu
    },
    {
      path: '/liga-personal/brackets',
      name: 'LigaPersonalBrackets',
      component: LigaPersonalBrackets
    },
    {
      path: '/liga-sekolah',
      name: 'LigaSekolahMenu',
      component: LigaSekolahMenu
    },
    {
      path: '/paket-mapel',
      name: 'ListPaketMapel',
      component: PaketMapel
    },
    {
      path: '/paket-mapel/form',
      name: 'FormMapel',
      component: FormMapel
    },
    {
      path: '/paket-mapel/:id',
      name: 'DetailPaketMapel',
      component: PaketMapelDetail
    },
    {
      path: '/paket-mapel/form/:id',
      name: 'FormEditMapel',
      component: FormMapel
    },
    {
      path: '/paket-bimbel',
      name: 'ListPaketBimbel',
      component: PaketBimbel
    },
    {
      path: '/paket-bimbel/form',
      name: 'FormBimbel',
      component: FormBimbel
    },
    {
      path: '/paket-bimbel/:id',
      name: 'FormBimbel-edit',
      component: FormBimbel
    },
    {
      path: '/liga-sekolah/brackets',
      name: 'LigaSekolahBrackets',
      component: LigaSekolahBrackets
    },
    {
      path: '/liga-sekolah/brackets',
      name: 'LigaSekolahBrackets',
      component: LigaSekolahBrackets
    },
    {
      path: '/content/article',
      name: 'ContentArticle',
      component: ContentArticle
    },
    {
      path: '/content/article-form',
      name: 'FormArticle',
      component: FormArticle
    },
    {
      path: '/content/article/:id',
      name: 'FormArticle-edit',
      component: FormArticle
    },
    {
      path: '/content/section',
      name: 'ContentSection',
      component: Content
    },
    {
      path: '/content/section-form',
      name: 'FormContent',
      component: FormContent
    },
    {
      path: '/content/section/:id',
      name: 'FormContent-edit',
      component: FormContent
    },
    {
      path: '/content/menu',
      name: 'ContentMenu',
      component: ContentMenu
    },
    {
      path: '/content/menu-form',
      name: 'FormMenu',
      component: FormMenu
    },
    {
      path: '/content/menu/:id',
      name: 'FormMenu-edit',
      component: FormMenu
    },
    {
      path: '/content/video',
      name: 'ContentVideo',
      component: ContentVideo
    },
    {
      path: '/content/video-form',
      name: 'FormVideo',
      component: FormVideo
    },
    {
      path: '/content/video/:id',
      name: 'FormVideo-edit',
      component: FormVideo
    },
    {
      path: '/content/banner',
      name: 'ContentBanner',
      component: ContentBanner
    },
    {
      path: '/content/banner-form',
      name: 'FormBanner',
      component: FormBanner
    },
    {
      path: '/content/banner/:id',
      name: 'FormBanner-edit',
      component: FormBanner
    },
    {
      path: '/content/itembank',
      name: 'FreeItemBank',
      component: ContentFreeItemBank
    },
    {
      path: '/content/itembank-form',
      name: 'ContentFreeItemBankForm',
      component: FormFreeItemBank
    },
    {
      path: '/content/itembank-import',
      name: 'FreeItemBankImport',
      component: FreeItemBankImport
    },
    {
      path: '/content/preview',
      name: 'PreviewContent',
      component: PreviewContent
    },
    {
      path: '/organizations',
      name: 'Organizations',
      component: Organizations
    },
    {
      path: '/organization/:id',
      name: 'Organization',
      component: OrganizationDetail
    },
    {
      path: '/organizations/form/:id?',
      name: 'OrganizationForm',
      component: OrganizationForm
    },
    {
      path: '/organizations-activation',
      name: 'OrganizationsActivation',
      component: OrganizationsActivation
    },
    {
      path: '/config',
      name: 'ConfigurationManagementForm',
      component: ConfigurationManagementForm
    },
    {
      path: '/sbmptn',
      name: 'SbmptnAdministration',
      component: Sbmptn
    },
    {
      path: '/sbmptn/top10',
      name: 'Top10UtbkRankinig',
      component: Top10UtbkRank
    },
    {
      path: '/voucher',
      name: 'Voucher',
      component: Voucher
    },
    {
      path: '/voucher/form',
      name: 'VoucherForm',
      component: VoucherForm
    },
    {
      path: '/ads-setting',
      name: 'AdsForm',
      component: AdsForm
    },
    {
      path: '/affiliate-dashboard',
      name: 'affiliate-dashboard',
      component: AffDashboard
    },
    {
      path: '/affiliate-redeem',
      name: 'affiliate-redeem',
      component: AffRedeem
    },
    {
      path: '/affiliate-setting',
      name: 'affiliate-setting',
      component: AffSetting
    },
    {
      path: '/tryout-regrading',
      name: 'tryout-regrading',
      component: Regrading
    },
    {
      path: '/push-notification',
      name: 'push-notification',
      component: PushNotif
    },
    {
      path: '/teachers',
      name: 'list-teacher',
      component: Teachers
    },
    {
      path: '/teacher-detail/:id',
      name: 'form-teacher',
      component: TeacherDetail
    },
    
  ],
  linkExactActiveClass: 'active'
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js